export default __webpack_public_path__ + "static/media/P1090017.dc6c746d.dc6c746d.JPG";